import { render, staticRenderFns } from "./AddCourse.vue?vue&type=template&id=2849bf4e&scoped=true&"
import script from "./AddCourse.vue?vue&type=script&lang=js&"
export * from "./AddCourse.vue?vue&type=script&lang=js&"
import style0 from "./AddCourse.vue?vue&type=style&index=0&id=2849bf4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2849bf4e",
  null
  
)

export default component.exports